<template>
  <div>
    <el-popover
      v-model="visible"
      popper-class="service-float-popover"
      placement="left"
      width="190"
      trigger="manual"
    >
      <div class="content">
        <div class="flex-start">
          <div>
            <p>{{ $t('standard.feedback') }}</p>
          </div>
        </div>
      </div>
      <!-- @click="handleClick" -->
      <div slot="reference" class="float-wrapper" @click="showFeedback">
        <img class="icon red" src="@/assets/common/icon_service.png" alt="">
        <img class="icon white" src="@/assets/common/icon_servicewhite.png" alt="">
      </div>
    </el-popover>
    <FeedbackDialog ref="detailDialog" />
  </div>
</template>

<script>
import FeedbackDialog from '@/components/FeedbackDialog'

let thisRef = null
export default {
  components: {
    FeedbackDialog
  },
  directives: {
    drag: (el) => {
      const dragBox = el
      let disX
      let disY
      dragBox.onmousedown = e => {
        disX = e.clientX - dragBox.offsetLeft
        disY = e.clientY - dragBox.offsetTop
      }
      dragBox.onmousemove = e => {
        const left = e.clientX - disX
        const top = e.clientY - disY
        dragBox.style.left = left + 'px'
        dragBox.style.top = top + 'px'
        thisRef && (thisRef.isDrag = true)
      }
      dragBox.onmouseup = e => {
        dragBox.onmousemove = null
        dragBox.onmouseup = null
        thisRef && (thisRef.isDrag = false)
      }
    }
  },
  data() {
    return {
      el: null,
      visible: false,
      isDrag: false
    }
  },
  computed: {
  },
  mounted() {
    thisRef = this
  },
  methods: {
    showFeedback() {
      this.$refs.detailDialog.showData()
    },
    handleClick() {
      this.visible = !this.visible
    }
  }
}
</script>

<style lang="scss" scoped>
.float-wrapper {
  position: fixed;
  width: 40px;
  height: 40px;
  right: 10px;
  bottom: 120px;
  background: #FFFFFF;
  border-radius: 50%;
  box-shadow: 0 6px 10px -10px rgba(0,0,0,0.10), 0 3px 12px 0 rgba(0,0,0,0.06);
  z-index: 1000;
  user-select: none;
  &:hover {
    cursor: grab;
    background: #E31D33;

    .white {
      display: block;
    }

    .red {
      display: none;
    }
  }

  .icon {
    position: absolute;
    width: 22px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  .white {
    display: none;
  }
}

.content {
  a {
    width: 100%;
    display: flex;
    align-items: center;
  }
  > div {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 8px;
    margin: 0 0 16px 0;
    border-radius: 6px;
    font-size: 16px;
    color: #333333;
    font-weight: 500;

    &.flex-start {
      align-items: flex-start;
    }

    &::before {
      position: absolute;
      top: -8px;
      left: 0;
      content: '';
      display: block;
      height: 1px;
      width: 100%;
      background: #E9E9E9;
    }

    &:first-child {
      &::before {
        display: none;
      }
    }

    &:last-child {
      margin-bottom: 8px;
    }

    &:hover {
      cursor: pointer;
      background: rgba(255,142,155,0.16);
    }

    p {
      margin: 0;
      padding: 3px 0;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>

<style>
.service-float-popover {
  padding: 8px 12px 0;
  border: none;
}
</style>
